
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dj/[id]",
      function () {
        return require("private-next-pages/dj/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dj/[id]"])
      });
    }
  